import { render, staticRenderFns } from "./Profit.vue?vue&type=template&id=d1f92264&scoped=true"
import script from "./Profit.vue?vue&type=script&lang=js"
export * from "./Profit.vue?vue&type=script&lang=js"
import style0 from "./Profit.vue?vue&type=style&index=0&id=d1f92264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f92264",
  null
  
)

export default component.exports